import React from 'react';
import {Route, Routes} from 'react-router-dom';
import {AuthGuard} from '../../components/AuthGuard';
import PodReviewPage from './podReview/PodReviewPage';
import PopReviewPage from './popReview/PopReviewPage';
import PodRiskReviewPage from './podRiskReview/PodRiskReviewPage';
import ExemptSpotCheckPage from './exemptSpotCheck/ExemptSpotCheckPage';
import ReviewTaskPage from './reviewTask/ReviewTaskPage';
import DspAppealSummaryPage from './dspAppealSummary/DspAppealSummaryPage';
import CentralExceptionPage from '../central/exceptions/CentralExceptionPage';
import QualityControlLayout from "./layouts/QualityControlLayout";
import CustomerServiceParcelsPage from './parcels/CustomerServiceParcelsPage';
import QCParcelsPage from './parcels/QCParcelsPage';
import {hasResource} from '../../utils/resourceAuth';
import {ResourceCode} from '../../constants/resourceCodes';
import {NoPermission} from '../../components/NoPermission';
import CsReportFilePage from "./download/CsReportFilePage";
import QcPenaltyUploadPage from './penaltyUpload/QcPenaltyUploadPage';
import WorkflowAdjustmentReviewPage from '../central/settlement/WorkflowAdjustmentReviewPage';
import WorkflowAdjustmentReviewDetailPage from '../central/settlement/WorkflowAdjustmentReviewDetailPage';
import UndeliverableUploadPage from "./undeliverable-upload/UndeliverableUploadPage";
import QcPodExemptListPage from './podExempt/QcPodExemptListPage';
import PodExemptReviewWorkbench from '../../components/podExempt/PodExemptReviewWorkbench';
import PodExemptDictManagePage from './podExempt/PodExemptDictManagePage';
import DriverVerificationListPage from './driver-verification/DriverVerificationListPage';
import DriverVerificationDetailPage from './driver-verification/DriverVerificationDetailPage';

const QualityControlRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<AuthGuard><QualityControlLayout /></AuthGuard>}>
                <Route path="podReview" element={<PodReviewPage/>}/>
                <Route path="popReview" element={<PopReviewPage/>}/>
                <Route path="podRiskReview" element={<PodRiskReviewPage/>}/>
                <Route path="exemptSpotCheck" element={<ExemptSpotCheckPage/>}/>
                <Route path="reviewTask" element={<ReviewTaskPage/>}/>
                <Route path="dspAppealSummary" element={<DspAppealSummaryPage/>}/>
                <Route path="exceptions" element={<CentralExceptionPage/>}/>
                <Route path="parcels" element={
                    hasResource([ResourceCode.cs.CS_PACKAGE]) ? <QCParcelsPage />
                        : hasResource([ResourceCode.cs.CS_PACKAGE_LITE]) ? <CustomerServiceParcelsPage />
                        : <NoPermission />
                }/>
                <Route path="penaltyUpload" element={<QcPenaltyUploadPage />} />
                <Route path="undeliverable-upload" element={<UndeliverableUploadPage />} />
                <Route path="pod-exempt" element={<QcPodExemptListPage />} />
                <Route path="pod-exempt/review/:reportId" element={<PodExemptReviewWorkbench role="QC" />} />
                <Route path="pod-exempt-dict" element={<PodExemptDictManagePage />} />
                <Route path="download" element={<CsReportFilePage />} />
                <Route path="settlement/adjustment-review" element={<WorkflowAdjustmentReviewPage />} />
                <Route path="settlement/adjustment-review/:instanceId/:bizId" element={<WorkflowAdjustmentReviewDetailPage />} />
                <Route path="driver-verification" element={<DriverVerificationListPage />} />
                <Route path="driver-verification/:driverAccountId" element={<DriverVerificationDetailPage />} />
            </Route>
        </Routes>
    );
};

export default QualityControlRoutes;
